export default "__VITE_ASSET__bJZzdRlF__"